import React from "react";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { routes } from "utilities/routing/generatedRoutes";

interface State {
  displayGuestlist: boolean
  displayScheduleConflicts: boolean
  isSaving: boolean
}

export default class DisplayPanel extends React.Component<unknown, State> {
  state: State = {
    displayGuestlist: site.userPreference.display.displayGuestlist,
    displayScheduleConflicts: site.userPreference.display.displayScheduleConflicts,
    isSaving: false
  };

  onDisplayGuestlistChange = () => {
    this.setState({ displayGuestlist: !this.state.displayGuestlist });
  };

  onDisplayScheduleConflictsChange = () => {
    this.setState({ displayScheduleConflicts: !this.state.displayScheduleConflicts });
  };

  onSave = () => {
    this.setState({ isSaving: true });

    window.CoreApi.UserPreference.UpdateDisplay({
      displayGuestlist: this.state.displayGuestlist,
      displayScheduleConflicts: this.state.displayScheduleConflicts
    })
      .then(() => { window.location.href = routes.personal_SettingMenu().absolute });
  };

  public render(): JSX.Element {
    return <>
      <table className="s1_table clean rowspace">
        <tbody>
          <tr>
            <td>
              {RESX.Guestlist.resxGuestlist}
            </td>
            <td>
              <Checkbox checked={this.state.displayGuestlist} onChange={this.onDisplayGuestlistChange} />
            </td>
          </tr>
          <tr>
            <td>
              {RESX.Exclusivity.ScheduleConflicts}
            </td>
            <td>
              <Checkbox checked={this.state.displayScheduleConflicts} onChange={this.onDisplayScheduleConflictsChange} />
            </td>
          </tr>
        </tbody>
      </table>
      <div className="flex justify-end margin-top-bigger">
        <button
          disabled={this.state.isSaving}
          type="button"
          onClick={this.onSave}
          className="button-new primary">
          {RESX.Buttons.btnSave}
        </button>
      </div>
    </>;
  }
}
